module.exports = __webpack_public_path__ + "img/Russian Federation.5da608ad.svg";